export default "__VITE_ASSET__BvY7qirM__"